import { FC } from 'react';
import MenuTree from './menuTree';
import SubMenu from './subMenu';
import MenuItem from './menuItem';
import {
  MenuTreeProps,
  SubMenuProps,
  MenuItemProps,
} from './interface';

export type IMenuTreeComponent = FC<MenuTreeProps> & {
  SubMenu: FC<SubMenuProps>;
  Item: FC<MenuItemProps>;
};
/** 菜单 */
const TransMenuTree = MenuTree as IMenuTreeComponent;
TransMenuTree.SubMenu = SubMenu;
TransMenuTree.Item = MenuItem;

export default TransMenuTree;